/** UI control state for the multi-year comparison view. Persists across renders. */
export type DeltaMode = 'pct' | 'chf';
/**
 * IS columns are periods (`incomeFromDate – incomeToDate`), so the two are visually
 * incompatible above the same column header.
 */
export type ReportScope = 'bilanz' | 'erfolg';

export interface ControlsState {
    /** Year labels currently selected (subset of harmonized.yearLabels). Newest first. */
    selectedYears: string[];
    /** Mode for the rightmost Gesamt-Δ column. */
    deltaMode: DeltaMode;
    /** Which sections to render. */
    reportScope: ReportScope;
    /** When true, an extra `In %` column appears next to each year (Verhältniskennzahl / common-size). */
    structMode: boolean;
    /** Composite ids of expanded tree nodes. */
    expandedNodes: string[];
}

export const DEFAULT_DELTA_MODE: DeltaMode = 'pct';
export const DEFAULT_REPORT_SCOPE: ReportScope = 'bilanz';
export const MIN_SELECTED_YEARS = 2;
/**
 * Hard upper bound on selected years. Enforced in 3 places, all of which
 * read this constant:
 *   - `year-pills.component`: disables additional pills past the cap.
 *   - `analytics.reducer` (initial load): clamps initial selection.
 *   - `analytics.reducer` (toggleYear): blocks adds beyond the cap.
 * The PDFTron row schema keeps 6 slots (`col0V..col5V`) for forward-compat;
 * the 6th slot is intentionally unused at this cap.
 */
export const MAX_SELECTED_YEARS = 5;
